module.exports = ".modalBackground {\n  height: 100vh;\n  width: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 1000;\n  cursor: pointer; }\n\n.modalWindow {\n  text-align: center;\n  padding: 30px;\n  border-radius: 5px;\n  z-index: 1001;\n  margin: 0 auto; }\n\n.modalWindow p {\n  color: white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/imageViewer/imageViewer.component.scss
// module id = ./src/app/components/imageViewer/imageViewer.component.scss
// module chunks = main